import { AbstractControl, ValidatorFn } from "@angular/forms";
import { differenceInYears, isValid, parseISO } from 'date-fns';

export function ageRangeValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const birth = typeof value === 'string' ? parseISO(value) : new Date(value);
    if (!isValid(birth)) {
      return { ageRange: true };
    }

    const age = differenceInYears(new Date(), birth);
    if (age < min || age > max) {
      return { ageRange: { min, max, age } };
    }

    return null;
  };
}

export interface AgeYear {
  age: number;
  year: number;
}

export function getAgeYearsFrom(birthDate: any, startAge: number, today: Date = new Date()): AgeYear[] {
  const birth = toDateObject(birthDate);
  if (!birth || !isValid(birth)) return [];

  const currentAge = differenceInYears(today, birth);
  if (currentAge < startAge) return [];

  return Array.from({ length: currentAge - startAge + 1 }, (_, index) => {
    const age = startAge + index;

    return { age, year: birth.getFullYear() + age };
  });
}

/**
* Converte uma string de data ou Timestamp do Firebase para objeto Date
* @param date String de data, Date ou Timestamp do Firebase
* @returns Objeto Date ou null se a entrada for inválida
*/
export function toDateObject(date: any): Date | null {
  if (!date) return null;

  if (typeof date.toDate === 'function') {
    return date.toDate();
  }

  if (date instanceof Date) {
    return date;
  }

  // Se for string, assume formato YYYY-MM-DD
  if (typeof date === 'string') {
    return new Date(date + 'T00:00');
  }

  return null;
}